import styled from "styled-components";
import { FaFacebook, FaTwitter, FaLinkedinIn, FaInstagram, FaDribbble, FaExternalLinkAlt } from "react-icons/fa";
import { BsFillPersonLinesFill } from "react-icons/bs";

interface CoordinatorProps {
  coordinator: {
    image: string;
    name: string;
    role: string;
    description: string;
    social: {
      facebook: string;
      twitter: string;
      linkedin: string;
      instagram: string;
      dribble: string;
      site: string;
      lattes: string;
    }
  }
};

export function Coordinator({ coordinator }: CoordinatorProps) {
  return(
    <CoordinatorItem>
      <CoordinatorImg src={coordinator.image} />
      <Card>
        <CoordinatorName>{coordinator.name}</CoordinatorName>
        <CoordinatorRole>{coordinator.role}</CoordinatorRole>
        {coordinator.social && (
          <Social>
            {coordinator.social.facebook && <Link href={coordinator.social.facebook} target="_blank"><FaFacebook /></Link>}
            {coordinator.social.twitter && <Link href={coordinator.social.twitter} target="_blank"><FaTwitter /></Link>}
            {coordinator.social.linkedin && <Link href={coordinator.social.linkedin} target="_blank"><FaLinkedinIn /></Link>}
            {coordinator.social.instagram && <Link href={coordinator.social.instagram} target="_blank"><FaInstagram /></Link>}
            {coordinator.social.dribble && <Link href={coordinator.social.dribble} target="_blank"><FaDribbble /></Link>}
            {coordinator.social.lattes && <Link href={coordinator.social.lattes} target="_blank"><BsFillPersonLinesFill/></Link>}
            {coordinator.social.site && <Link href={coordinator.social.site} target="_blank"><FaExternalLinkAlt/></Link>}
          </Social>
        )}
      </Card>
      <CoordinatorDescription>{coordinator.description}</CoordinatorDescription>
    </CoordinatorItem>
  );
};

const CoordinatorItem = styled.li`
  width: 344px;
  margin: 0 16px;

  @media screen and (max-width: ${({ theme }) => theme.device.mobile}) {
    margin: 0 auto;
  }
`;

const Card = styled.div`
  background-color: #fff;
  height: 156px;
  box-shadow: 0px 3px 3px -1px rgb(0, 0, 0, 0.1);
  padding: 24px;
`;

const CoordinatorImg = styled.img`
  display: block;
  width: 100%;
  height: auto;
`;

const CoordinatorName = styled.span`
  display: block;
  font-size: 18px;
  color: ${({ theme }) => theme.colors.black.dark};
  margin-bottom: 8px;
  `;

const CoordinatorRole = styled.span`
  display: block;
  font-size: 16px;
  color: ${({ theme }) => theme.colors.black.light};
  margin-bottom: 42px;
`;

const Social = styled.div`
  display: flex;
  align-items: center;

  * {
    color: ${({ theme }) => theme.colors.gray.darker};
    margin-right: 6px;
  }
`;

const CoordinatorDescription = styled.span`
  display: block;
  font-size: 16px;
  color: ${({ theme }) => theme.colors.gray.darker};
  margin-bottom: 42px;
  padding: 12px 12px 0;
  line-height: 1.4;
`;

const Link = styled.a``;